import React from 'react'
import { CardHeader as ReactstrapCardHeader, CardHeaderProps } from 'reactstrap'

export const CardHeader: React.FC<CardHeaderProps> = props => {
  return <ReactstrapCardHeader {...props} />
}
